import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        form: '='
    },
    template: `
        <div ui-tree>
            <div ui-sortable="vm.sortableOptions" ng-model="vm.list.items" ng-if="vm.list.items.length">
                <div class="block02" ng-class="{ open: vm.toggles[$index]===true }" ng-repeat="item in vm.list.items">
                    <div class="heading01">
                        <span class="ico-move category" ng-if="!item.isWithoutCategory && vm.canManageQuestion">{{ 'forms.Drag' | translate }}</span>
                        <h3 ng-click="vm.toggles[$index]=!vm.toggles[$index];">
                            <span ng-if="item.activeI18n">{{ item.activeI18n.name }}</span>
                            <span ng-if="item.isWithoutCategory">{{ 'forms.Questions without categories' | translate }}</span>
                        </h3>
                    </div>
                    <div ng-if="vm.toggles[$index]" class="form tablewrapper">
                        <forms-forms-form-questions-question
                            questions="item.questions"
                            form="vm.form"
                        />
                    </div>
                </div>
            </div>
        </div>
    `
})

export default class {
    constructor ($translate, toastr, FormResource, FormService) {
        this.$translate = $translate;
        this.toastr = toastr;
        this.FormResource = FormResource;
        this.FormService = FormService;
    }

    $onInit () {
        this.canManageQuestion = this.FormService.canManageForm(this.form);
        this.toggles = [];
        this.sortableOptions = {
            handle: '.ico-move',
            stop: () => this.updateSequence()
        };
    }

    updateSequence () {
        const categoryIds = this.list.items
            .map(item => item.id)
            // filter out null value
            .filter(Boolean);

        this.FormResource.updateQuestionCategorySequence({
            categoryIds,
            formId: this.form.id
        }).$promise
            .then(() => this.toastr.success(this.$translate.instant('forms.Question category sequence updated')))
            .catch(() => this.toastr.error(this.$translate.instant('forms.Question category sequence update failed')));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/forms/form/questions/category/index.js